export default __webpack_public_path__ + "static/media/money.2e18c561.svg";